<template>
  <div>
    <ul class="ul-caption">
      <li>
        <p class="title">경기별기록</p>
      </li>
      <li>
        <select class="select-none-line" v-model="seasonSelect" @change="getRecord">
          <option
            v-for="(ver, i) in seasonList"
            :key="i"
            :value="ver.code">
            {{ver.code}}
          </option>
        </select>
      </li>
    </ul>
    <div class="match-history">
      <table>
        <thead>
        <tr>
          <td v-for="(item, index) in headList" :key="index">{{item}}</td>
        </tr>
        </thead>
        <tbody v-if="recordList.length">
        <tr v-for="(item, index) in recordList" :key="index">
          <td>{{item.Game_Date}}</td>
          <td>
            <img :src="getEmblem(item.team)" alt="">
            {{item.team_name}}
          </td>
          <td>
            <img :src="getEmblem(item.opponent_team)" alt="">
            {{item.opponent_team_name}}
          </td>
          <td>{{item.Work_Des}}</td>
          <td>{{item.Change_i_Des}}</td>
          <td>{{item.Change_o_Des}}</td>
          <td>{{item.Goal_Qty}}</td>
          <td>{{item.Assist_Qty}}</td>
          <td>{{item.St_Qty}}/{{item.St_Valid_Qty}}</td>
          <td>{{item.Fo_Qty}}/{{item.Fs_Qty}}</td>
          <td>{{item.Os_Qty}}</td>
          <td>{{item.Warn_Qty}}</td>
          <td>{{item.Exit_Qty}}</td>
          <td>{{item.loss_Point}}</td>
          <td>{{item.Self_Goal_Qty}}</td>
        </tr>
        </tbody>
        <tbody v-else>
        <tr>
          <td colspan="15">데이터가 없습니다.</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import {getEmblem, getNewYearList, getYearList} from '@/lib';
import dayjs from "dayjs";

export default {
  name: 'MatchHistory',
  data() {
    return {
      headList: [
        '일시', '소속팀', '상태팀', '출장', '교체 IN', '교체 OUT', '득점',
        '도움', '슈팅(S/T)', '파울(C/S)', 'OS', '경고',  '퇴장', '실점', '자책'
      ],
      recordList: [],
      seasonSelect: null,
      seasonList: [],
    }
  },
  created() {
    this.seasonList = getYearList(this.$store.state.year);
    this.seasonSelect = this.seasonList[this.seasonList.length-1].code;
  },
  mounted () {
    this.getRecord();
  },
  methods: {
    getEmblem,
    async getRecord() {
      // console.log('>>> ', this.seasonSelect);
      const {data} = await this.$http.get(`/player/per_game?player_id=${this.$route.params.id}&year=${this.seasonSelect}`);
      // console.log('경기별기록 ', data);
      if(data.success && data.data) {
        this.recordList = data.data.game;

        this.recordList.map(item => {
          item.Game_Date = dayjs(item.Game_Date).format('YYYY-MM-DD');
        })
      }

      // this.recordList = [
      //   {
      //     date: '2023-12-26',
      //     name: '배다솔',
      //     home_team: '전남',
      //     home_emblem: 'K07',
      //     away_team: '전남',
      //     away_emblem: 'K07',
      //     enter: '출장',
      //     in: '후반10(28)',
      //     out: '후반0(27)',
      //     score: '0/0',
      //     support: '0',
      //     fc: '0',
      //     fs: '0',
      //     shooting: '0',
      //     valid: '0',
      //     os: '0',
      //     warning: '0',
      //     exit: '0',
      //     lose: '0',
      //   }
      // ];
    }
  }
}
</script>
